<template>
  <div class="top-filter-logic-block">
    <div class="expression" v-bind:class="definition.classes">
      <label v-if="definition.isList">{{ definition.title }}</label>

      <div class="arg" v-if="definition.isList" v-for="(arg, argId) in expression.args">
        <select v-if="argId > 0" :value="expression.type" @change="setType">
          <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
        </select>
        <top-filter-logic-block :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                           :parent="definition" @delete="deleteArg(argId)"></top-filter-logic-block>
      </div>

      <span class="binaryArgs" v-if="definition.isBinary">
        <SingleSelect v-if="definition.left == 'column'"
                      :value.sync="expression.args[0]" :options="columns"
                      :display="(c) => translateColumn(c)"></SingleSelect>
  <!--      <select v-if="definition.left == 'column'" v-model="expression.args[0]">
          <option v-for="column in columns" v-bind:value="column">{{ column }}</option>
        </select>-->
        <SingleSelect :value="operatorObject(expression.type)" :options="possibleOperators"
                      @update:value="setType"
                      :display="(c) => translateOperator(c)"></SingleSelect>

        <div class="mdl-textfield mdl-js-textfield" v-if="definition.right == 'const' || definition.right == 'regex'">
          <input class="mdl-textfield__input" type="text" id="v"
                 v-model="expression.args[1]">
          <label class="mdl-textfield__label" for="v">Value</label>
        </div>
      </span>

      <select v-if="expression.args.length == 0" :value="expression.type" @change="setType">
        <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
      </select>

      <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg">
        <i  class="material-icons">add</i> Add
      </button>

    </div>
  </div>
</template>

<script>
  import expression from "../../logic/expression.js"
  import SingleSelect from "../utils/SingleSelect.vue"
  import i18n from "i18n"

  export default {
    name: 'top-filter-logic-block',
    props: {
      columns: {
        type: Array,
        default: function () {
          return []
        }
      },
      expression: {
        type: Object,
        default: function() {
          return {
            type: "and",
            args: []
          }
        }
      },
      parent: {
        type: Object,
        default: function() {
          return null
        }
      }
    },
    components: {
      SingleSelect
    },
    data () {
      return {

      }
    },
    computed: {
      definition() {
        return expression.operatorsByName.get(this.expression.type)
      },
      possibleOperators() {
        return expression.operators.filter(x => x.isBinary)
      }
    },
    watch: {
    },
    methods: {
      i18n() { return i18n().filter },
      translateColumn(col) {
        return i18n().translateColumnName(col)
      },
      translateOperator(operator) {
        return this.i18n().operators[operator.title] || "i18n:"+operator.title
      },
      operatorTitle(type) {
        for(let op of this.possibleOperators) {
          if(op.type == type) return op.title
        }
      },
      operatorDefinition(expr) {
        const operator = expression.operatorsByName.get(expr.type)
        console.log("OP", operator)
        return operator
      },
      operatorObject(name) {
        for(let op of this.possibleOperators) {
          if(op.name == name) return op
        }
      },
      addArg() {
        var narg = expression.newArg(this.expression, this.columns)
        this.$emit('update:expression', {
          type: this.expression.type,
          args: this.expression.args.concat([narg])
        })
      },
      setArg(argId, ev) {
        console.log("SET ARG", argId, ev)
        const nArgs = this.expression.args.slice()
        nArgs[argId] = ev
        this.$emit('update:expression', {
          type: this.expression.type,
          args: nArgs
        })
      },
      deleteArg(argId) {
        console.log("DELETE ARG", argId)
        const nArgs = this.expression.args.slice()
        nArgs.splice(argId, 1)
        this.$emit('update:expression', {
          type: this.expression.type,
          args: nArgs
        })
      },
      setType(v) {
        let nType = v.name
        var nDefinition = expression.operatorsByName.get(nType)
        console.log("SET TYPE", nType)
        if(!this.definition.isLogical && nDefinition.isLogical) {
          this.$emit('update:expression', {
            type: nType,
            args: [JSON.parse(JSON.stringify(this.expression))]
          })
        } else if(this.definition.isLogical && !nDefinition.isLogical) {
          this.$emit('update:expression', {
            type: nType,
            args: [nDefinition.defaultArgs(this.columns)]
          })
        }/* else if ((this.definition.element != nDefinition.element)
          || (this.definition.left != nDefinition.left)
          || (this.definition.right != nDefinition.right)) {
          console.log("RESET ARGS")
          this.$emit('update:expression', {
            type: nType,
            args: nDefinition.defaultArgs(this.columns)
          })
        }*/ else {
          console.log("HOLD ARGS")
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          })
        }
      },
      deleteThis() {
        this.$emit('delete')
      },
      updated () {
        componentHandler.upgradeAllRegistered()
      },
      mounted () {
        componentHandler.upgradeAllRegistered()
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top-filter-logic-block {
    display: inline-block;
  }

  .expression {
  }

  .expression > button {
  }

  .expression > button i {
  }
  .expression > .delete-button {

  }

  .logical.expression {
  }
  .logical label {
  }
  .logical.expression > button {
  }

  .compare.expression {
  }
  .compare label {
  }
  .compare.expression > button {
  }

  .expression {
  }

  .binaryArgs > div {
    max-width: 150px;
  }
  .binaryArgs > div:nth-child(2) {
    max-width: 100px;
  }

  .mdl-textfield {
    padding-top: 0;
    padding-bottom: 0;
  }

  .mdl-textfield__label:after {
    bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// TopFilterLogicBlock.vue?7ba5fb2b